<script>
export default {
  name: 'CtaPremium',

  props: {
    packs: Array,
    countriesList: Array,
    currency: String,
    label: String,
    css: String,
    settingsCustom: Object,

    settingsSupport: {
      type: Object,
      required: false,
    },

    premiumOnly: Boolean,
    payNowPossible: Boolean,
  },

  methods: {
    openPremiumModal() {
      this.$root.openPremiumFormPopup({ ...this.$props })
    },
  },
}
</script>

<template>
  <button
    :class="css"
    class="btn mb-8"
    @click="openPremiumModal">
    {{ label }}
  </button>
</template>
